import React from "react";
import "./about.css";
import certificado from '../../img/cert-1.png'

function About() {
  return (
    <div className="a">
      <div className="a-left">
        <div className="a-card bg"></div>
        <div className="a-card">
          <img
            src="https://media.istockphoto.com/vectors/laptop-notebook-flat-design-vector-illustration-vector-id519121770?k=20&m=519121770&s=170667a&w=0&h=yzzBrL550BIFnK98Zlk-v_4pil5dA2VOBL2RDSufAS8="
            alt="imagem"
            className="a-img"
          />
        </div>
      </div>
      <div className="a-right">
          <h1 className="a-title">Sobre Mim</h1>
          <p className="a-sub">
              Um menino que achou na tecnologia uma forma de realizar seus sonhos e
              ajudar as pessoas em seus desafios diários!
          </p>
          <p className="a-desc">
            Por ser apaixonado por tecnologia e inovação, achei na programação uma forma
            de atingir meus objetivos e concretizar minhas ideias. Estudo Desenvolvimento Web
            na escola de programação Trybe e curso Engenharia de Computação. Trabalho com
            Desenvolvimento Front-end na construção de projetos de websites modernos e bem estruturados.
          </p>
          <div className="a-award">
            <img src={certificado} alt="imagem" className="a-award-img" />
            <div className="a-award-texts">
                <h4 className="a-award-title">Certificado de Fundamentos do Desenvolvimento Web</h4>
                <p className="a-award-desc">Diversos conceitos foram trabalhados neste módulo como: JS, React, Testes automatizados, Git, Redux, Context API</p>
            </div>
          </div>
      </div>
    </div>
  );
}

export default About;
